/* eslint-disable max-len */
export const nl = {
    translation: {
        links: {
            forgotPassword: 'Wachtwoord vergeten',
            forgotPasswordURL:
                'https://valueblue.zendesk.com/hc/nl/articles/115002753109-Mijn-wachtwoord-is-kwijt-wat-nu-',
            needLoginHelp: 'Hulp met inloggen',
            vbLogin: 'Inloggen met ValueBlue',
            help: 'Hulp',
            cookiePrivacyStatement: 'Privacy en cookie verklaring',
            cookiePrivacyStatementURL:
                'https://cdn.bluedolphin.valueblue.nl/docs/PrivacyCookieStatement.pdf',
            vbAcademy: 'ValueBlue Academy',
            vbAcademyURL: 'https://valueblue.nl/academy/',
            community: 'Community',
            communityURL: 'https://valueblue.zendesk.com/hc/nl',
            webinars: 'Webinars',
            webinarsURL: 'https://www.valueblue.nl/events/',
        },
        signIn: {
            title: 'Inloggen bij ',
            description: 'Kies je identiteitsprovider',
        },
        errors: {
            title: 'Oeps!',
            signUpDescription: 'De link is ongeldig.',
            noIdpDescription:
                'Je moet minstens één actieve identiteitsprovider hebben om te kunnen inloggen.',
            genericDescription: 'Er is iets fout gegaan.',
            text: 'Vraag je beheerder voor meer informatie.',
        },
        unSupportedBrowser: {
            warning:
                '<strong>Deze browser wordt niet ondersteund.</strong><br>Voor een optimale beleving,<br>gebruik Microsoft Edge, Chrome, of Firefox',
        },
        loginErrors: {
            sessionExpired:
                'Uw sessie is verlopen. U dient opnieuw inloggen zodat BlueDolphin uw authenticatie gegevens kan verversen.',
            default:
                'Authenticatie mislukt. Probeer opnieuw in te loggen. Neem contact op met de beheerder als deze foutmelding zich blijft voordoen.',
            userAccountNotExists:
                'Authenticatie mislukt. Account niet gevonden. Neem contact op met de beheerder.',
        },
        tabTitle: 'Login - BlueDolphin',
        profileTitle: 'Profile - BlueDolphin',
        internetConnection: {
            lost: 'Geen internetconnectie. Maak opnieuw verbinding om verder te werken',
            restored: 'We zijn terug! Je kunt je werk weer hervatten',
        },
        modalErrorActions: {
            refresh: 'Herlaad',
        },
        profile: {
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            email: 'Email',
            personal: 'Persoonlijke informatie',
            work: 'Werk informatie',
            preference: 'Voorkeuren',
            functions: 'Jouw rol',
            functionPlaceholder: 'Selecteer jouw rol',
            coworker: 'Je collegas',
            coworkerPlaceholder: 'Selecteer je antwoord(en)',
            responsibility: 'jouw verantwoordelijkheden',
            responsibilityPlaceholder: 'Selecteer je verantwoordelijkheden',
            department: 'Jouw afdeling',
            departmentPlaceholder: 'Selecteer je afdeling',
            defaultViewMode:
                'In welke standaard modus wil je jouw eigen werksets openen?',
            mode: {
                editMode: 'Bewerkingsmodus',
                viewMode: 'Weergavemodus',
            },
            privacyText: 'Privacy- en cookieverklaring',
            settings: 'Gebruikers instellingen',
            nav: {
                profileTab: 'Profiel',
            },
        },
        functions: {
            enterprise_architect: 'Enterprisearchitect',
            business_architect: 'Bedrijfsarchitect',
            process_architect: 'Procesarchitect',
            security_architect: 'Beveiligingsarchitect',
            information_architect: 'Informatiearchitect',
            application_architect: 'Applicatiearchitect',
            integration_architect: 'Integratiearchitect',
            infra_architect: 'Infra-architect',
            solution_architect: 'Oplossings(project)architect',
            process_engineer: 'Procesingenieur',
            integration_specialist: 'Integratiespecialist',
            infra_solution_designer: 'Ontwerper infra-oplossingen',
            information_data_designer: 'Informatie-/gegevensontwerper',
            business_consultant: 'Bedrijfsadviseur',
            application_portfolio_manager: 'Applicatieportfoliomanager',
            project_portfolio_manager: 'Projectportfoliomanager',
            functional_application_manager: 'Functioneel Applicatiemanager',
            technical_application_manager: 'Technisch Applicatiebeheer',
            technical_maintenance: 'Technisch Beheer',
            service_manager: 'Servicemanager',
            cio_cfo: 'CIO / CFO',
            it_operations_manager: 'IT-operationsmanager',
            business_continuity_manager: 'Bedrijfscontinuïteitsmanager',
            project_manager: 'Projectmanager',
            vendor_manager: 'Leveranciersmanager',
            compliance_manager: 'Compliancemanager',
            business_manager: 'Businessmanager',
            servicedesk_employee: 'Servicedeskmedewerker',
            business_employee: 'Businessmedewerker',
            other: 'Anders',
            privacy_officer: 'Privacy functionaris',
            security_officer: 'Security functionaris',
            information_manager: 'Informatiemanager',
            analyst: 'Analyst',
            bluedolphin_admin: 'BlueDolphin admin',
        },
        responsibilities: {
            business_capability_modelling:
                'Modelleren van bedrijfscapaciteiten',
            bi_architecture: 'BI-architectuur',
            application_portfolio_management: 'Applicatie portfolio management',
            infra_netwerk_design: 'Infra-/netwerkontwerp',
            business_architecture: 'Businessarchitectuur',
            engineering: 'Engineering',
            organizational_design: 'Organisatieontwerp',
            data_modelling: 'Datamodellering',
            application_architecture: 'Applicatiearchitectuur',
            application_integration: 'Applicatie-integratie',
            implement_it_industry_standards:
                'IT-industriestandaarden implementeren',
            security: 'Beveiliging',
            services_design: 'Dienstenontwerp',
            determine_architecture_principles: 'Architectuurprincipes bepalen',
            roadmapping_strategy: 'Roadmapping – Strategie',
            roadmapping_projects: 'Roadmapping – Projecten',
            project_architecture_designs: 'Project architectuur ontwerpen',
            architecture_visualization: 'Architectuurvisualisatie',
            building_block_design: 'Bouwsteenontwerp',
            solutions_modelling: 'Modelleren van oplossingen',
            business_analysis:
                'Bedrijfsanalyse (gebruikmakend van bijvoorbeeld statistische tools, getailleerde methodes of testprocedures)',
            project_portfolio_management: 'Projectportfolio management',
            stakeholder_management: 'Stakeholder management',
            risk_management: 'Risico management',
            internal_communications: 'Interne communicatie',
            create_requirements: 'Voorschriften opstellen',
            progress_reporting: 'Voortgangsrapportage',
            other: 'Anders',
        },
        departments: {
            it_general: 'IT Algemeen',
            it_architecture: 'IT Architectuur',
            it_infra: 'IT Infra',
            it_operations: 'IT Operaties',
            it_development: 'IT Ontwikkeling',
            human_resoure_management: 'Human resources management',
            risk_control: 'Risico en Controle',
            manufacturing: 'Fabricage',
            finance: 'Financiën',
            marketing: 'Marketing ',
            communications: 'Communicatie',
            service_department: 'Serviceafdeling',
            customer_support: 'Klantenondersteuning',
            procurement: 'Inkoop',
            sales: 'Verkoop',
            operations: 'Operaties',
            production: 'Productie',
            engineering: 'Engineering',
            research_development: 'Onderzoek en Ontwikkeling',
            data_analysis: 'Data-analyse',
            project_management: 'Project management',
            information_management: 'Informatie management',
            security: 'Beveiliging',
            general_management: 'Algemeen management',
            other_business_department: 'Andere Bedrijfsafdeling',
            other_it_department: 'Andere IT-afdeling',
            other: 'Anders',
        },
    },
};
